import React from 'react'
import { Modal, Button } from 'react-bootstrap';

function ConfirmBox(props) {

    return (
        <>

            <Modal
                show={props.show}
                onHide={() => props.setShowConfirmBox(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.message}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => props.onConfirmClick(props.eventInfo, props.dataInfo)}>Yes</Button>
                    <Button variant="secondary" onClick={() => props.setShowConfirmBox(false)}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
function ConfirmBoxAlert(props) {

    return (
        <>

            <Modal
                show={props.show}
                onHide={() => props.setShowConfirmBox(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={props.cssClass ? props.cssClass : ""}>
                    {props.message}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => props.onConfirmClick(props.eventInfo, props.dataInfo)}>Ok</Button>
                   
                </Modal.Footer>
            </Modal>
        </>
    );
}
export {ConfirmBox,ConfirmBoxAlert}